import { defineComponent as _defineComponent } from 'vue'
import { LayoutTagGetResponse_WordSetting } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";


/**
 * いいねUI。
 */

interface Props {
	/**
	 * 投稿が許可されてるかどうか。
	 */
	isPostable: boolean;
	/**
	 * いいね送付後かどうか。
	 */
	isPosted: boolean;
	/**
	 * いいね数。
	 */
	niceCount: number;
	/**
	 * 文字列設定
	 */
	wordSettings?: LayoutTagGetResponse_WordSetting | null;
}
interface Emits {
	(e: "on-click-nice"): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    isPostable: { type: Boolean, required: true },
    isPosted: { type: Boolean, required: true },
    niceCount: { type: Number, required: true },
    wordSettings: { type: null, required: false }
  },
  emits: ["on-click-nice"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: "on-click-nice"): void;
}), expose: any, slots: any, attrs: any }) {
  expose()




const onclick = (): void => {
	emit("on-click-nice");
};

const __returned__ = { emit, onclick }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})